import React from 'react'

import { IconProps } from '@/components/ui/icons/types'

const svgHtml = `<defs> <path d="M30.5,6.25 L6.25,30 L30.5,6.25 Z M16.5885281,18.125 L5.37537109,7.14304215 C4.88215753,6.65999794 4.87391365,5.86858465 5.35695785,5.37537109 C5.84000206,4.88215753 6.63141535,4.87391365 7.12462891,5.35695785 L18.375,16.3753625 L29.6253711,5.35695785 C30.1185847,4.87391365 30.9099979,4.88215753 31.3930421,5.37537109 C31.8760864,5.86858465 31.8678425,6.65999794 31.3746289,7.14304215 L20.1614719,18.125 L31.3746289,29.1069579 C31.8678425,29.5900021 31.8760864,30.3814153 31.3930421,30.8746289 C30.9099979,31.3678425 30.1185847,31.3760864 29.6253711,30.8930421 L18.375,19.8746375 L7.12462891,30.8930421 C6.63141535,31.3760864 5.84000206,31.3678425 5.35695785,30.8746289 C4.87391365,30.3814153 4.88215753,29.5900021 5.37537109,29.1069579 L16.5885281,18.125 Z" id="path-1"></path> </defs> <g id="Modals" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"> <g id="verify---step-1" transform="translate(-431.000000, -87.000000)"> <g id="Modal" transform="translate(420.000000, 82.000000)"> <g id="icons/close" transform="translate(6.000000, 0.000000)"> <mask id="mask-2" fill="white"> <use xlink:href="#path-1"></use> </mask> <use id="Mask" fill="#FFFFFF" fillRule="nonzero" xlink:href="#path-1"></use> <g id="colors/primary/_main" mask="url(#mask-2)"> <g id="colors/primary/white"></g> </g> </g> </g> </g> </g>`

type CloseIconProps = Partial<IconProps>

export const CloseIcon: React.FC<CloseIconProps> = (props) => {
  const { size } = props

  return (
    <svg
      width={`${size?.width}px`}
      height={`${size?.height}px`}
      viewBox="0 0 27 27"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      dangerouslySetInnerHTML={{ __html: svgHtml }}
    />
  )
}

CloseIcon.defaultProps = {
  size: {
    width: 27,
    height: 27,
  },
}
